import {
    REPORT_FOOTER_MEASUREMENT_ID,
    REPORT_HEADER_MEASUREMENT_ID,
    REPORT_PATIENT_INFO_MEASUREMENT_ID,
    REPORT_SIGNATURE_MEASUREMENT_ID,
} from '@/components/preview/pagination/constants';
import { A4_PAGE_WIDTH } from '@/constants';
import { MeasureWrapper } from '../MeasureWrapper';
import PreviewPsychologistSignature from '../PreviewPsychologistSignature';
import { ReportFooter } from '../ReportFooter';
import { ReportHeader } from '../ReportHeader';
import StandalonePatientInfoTable from './StandalonePatientInfoTable';
import type { Psychologist, ReportData } from '../types';

interface StandaloneFixedMeasurerProps {
    data: ReportData;
    psychologist: Psychologist | null;
}

export default function StandaloneFixedMeasurer({
    data,
    psychologist,
}: StandaloneFixedMeasurerProps) {
    const footerMeasureStyle = {
        marginLeft: '-3rem',
        marginRight: '-3rem',
        width: A4_PAGE_WIDTH,
    };

    return (
        <div
            aria-hidden="true"
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: A4_PAGE_WIDTH,
                visibility: 'hidden',
                pointerEvents: 'none',
                zIndex: -1000,
                padding: '3rem',
            }}
            className="report-measurement-container"
        >
            <MeasureWrapper id={REPORT_HEADER_MEASUREMENT_ID}>
                <ReportHeader data={data} psychologist={psychologist} />
            </MeasureWrapper>

            <MeasureWrapper id={REPORT_PATIENT_INFO_MEASUREMENT_ID}>
                <StandalonePatientInfoTable data={data} psychologist={psychologist} />
            </MeasureWrapper>

            <MeasureWrapper id={REPORT_FOOTER_MEASUREMENT_ID} style={footerMeasureStyle}>
                <ReportFooter
                    data={data}
                    currentPage={1}
                    totalPages={2}
                    psychologist={psychologist}
                />
            </MeasureWrapper>

            <MeasureWrapper id={REPORT_SIGNATURE_MEASUREMENT_ID}>
                <PreviewPsychologistSignature
                    full_name={psychologist?.full_name}
                    crp={psychologist?.crp}
                    city={psychologist?.city}
                    state={psychologist?.state}
                />
            </MeasureWrapper>
        </div>
    );
}
